export const LEGAL_ACCEPTANCE_VERSION = '2026-05-06';
export const PRIVACY_POLICY_VERSION = '2026-04-26';

export const LEGAL_DOCUMENT_TYPES = [
  'terms_of_service',
  'privacy_policy',
  'financial_acknowledgment',
] as const;

export type LegalDocumentType = typeof LEGAL_DOCUMENT_TYPES[number];

export type RequiredLegalDocument = {
  type: LegalDocumentType;
  version: string;
  title: string;
  url: string;
  contentHash: string;
};

export const FINANCIAL_ACKNOWLEDGMENT_TEXT =
  'I understand Per Diem is an informational planning tool, not a financial adviser, investment adviser, broker, tax adviser, accountant, attorney, or fiduciary, and I should consult qualified professionals before making financial, investment, tax, or legal decisions.';

export const SUBSCRIPTION_ACKNOWLEDGMENT_TEXT =
  'I understand the paid plan I choose renews automatically unless I cancel it through the platform where I purchased it.';

export const REQUIRED_LEGAL_DOCUMENTS: RequiredLegalDocument[] = [
  {
    type: 'terms_of_service',
    version: LEGAL_ACCEPTANCE_VERSION,
    title: 'Terms of Service',
    url: 'https://perdiem.app/terms-of-service',
    contentHash: 'sha256:c8fcc54bef6a6359ed460c219ba96154a2cbaf13af65969972f4e2fc4787333b',
  },
  {
    type: 'privacy_policy',
    version: PRIVACY_POLICY_VERSION,
    title: 'Privacy Policy',
    url: 'https://perdiem.app/privacy-policy',
    contentHash: 'sha256:a3faf0f728548ce825b224f83cc8a82bbbccaf8d4bfc341d590c55e83ec2e582',
  },
  {
    type: 'financial_acknowledgment',
    version: LEGAL_ACCEPTANCE_VERSION,
    title: 'Financial Product Acknowledgment',
    url: 'https://perdiem.app/terms-of-service#disclaimers',
    contentHash: 'sha256:905653d9c4c7b6e8ea4141f04c5d43c736bc9efe46456f2c193266df723c197a',
  },
];

export const SUBSCRIPTION_TERMS_DOCUMENT = {
  type: 'subscription_terms',
  version: LEGAL_ACCEPTANCE_VERSION,
  title: 'Subscription Renewal Acknowledgment',
  url: 'https://perdiem.app/terms-of-service#subscriptions',
  contentHash: 'sha256:2a0c964202947314a36a7307c8536045a87b48042dce945b43fe6352a86b0cdc',
} as const;
